export default __webpack_public_path__ + "static/media/fatturazione-elettronica-dark.93da67f8.svg";